import { PhoneNumberUtil } from "google-libphonenumber"

import { FieldValidator } from "./"

const phoneUtils: PhoneNumberUtil = PhoneNumberUtil.getInstance()
const REGION = "US"
const DIGITS_REGEXP = /[^0-9]/g
const REQUIRED_MESSAGE = "Phone number is required."
const INVALID_MESSAGE = "Please enter a valid phone number."

export const validatePhoneNumber: FieldValidator = value => {
  if (value) {
    const parsedPhoneNumber = value.replace(DIGITS_REGEXP, "")

    if (!parsedPhoneNumber) {
      return REQUIRED_MESSAGE
    }

    try {
      const phoneNumber = phoneUtils.parseAndKeepRawInput(parsedPhoneNumber, REGION)

      if (!phoneUtils.isValidNumberForRegion(phoneNumber, REGION)) {
        return INVALID_MESSAGE
      }
    } catch (e) {
      return INVALID_MESSAGE
    }

    return null
  }

  return REQUIRED_MESSAGE
}
